import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Route wrapper that requires the current user to have one of the allowed roles.
 * Unauthenticated -> /auth/login
 * Wrong role      -> /  (do NOT rely on URL obscurity)
 */
const RoleProtectedRoute = ({ children, allowedRoles = ['admin', 'super_admin'] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700"></div>
      </div>
    );
  }

  if (!user) {
    const next = location.pathname + (location.search || '');
    return <Navigate to={`/auth/login?next=${encodeURIComponent(next)}`} state={{ from: location }} replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    // Check-in staff have limited access - redirect them to /check-in
    if (user.role === 'check_in_staff') {
      return <Navigate to="/check-in" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleProtectedRoute;
